import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import Login from '../pages/auth/Login';
import { routes } from './Sidebar';
import Sidebar from '../comman/Sidebar';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword'
import LoginSuccess from '../pages/auth/passwordResetSuccess';
import Header from '../comman/Header';
import Error from '../components/not-found/Error';
import MobileVerifyEmail from '../pages/auth/MobileVerifyEmail';
import ResetPasswordUser from '../pages/auth/ResetPasswordUser';
import OtpVerify from '../pages/auth/OtpVerify';


const Routing = () => {
  const SidebarLayout = () => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  );

  return (
    <Routes>
      {/* ------------------------------------- before Login Routes----------------------------------------------------- */}
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-otp" element={<OtpVerify />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/password-reset-success" element={<LoginSuccess />} />

      <Route path="email-verified/:token" element={<MobileVerifyEmail />} />
      <Route path="/reset-password-user/:token" element={<ResetPasswordUser />} />


      {/* <Route path="/content-reader" element={<CmsContenttReader />} /> */}

      {/* ------------------------------------- After Login Routes----------------------------------------------------- */}
      <Route element={<SidebarLayout />}>
        {routes([]).map(({ id, path, element }) => (
          <Route key={id} path={path} element={element} />
        ))}
      </Route>
      <Route path='*' element={<Error />} />
    </Routes >
  );
};

export default Routing;
